import { get } from 'lodash-es';

const byTotalPages = (state: any) => get(state, 'resultList.totalPages');

export default byTotalPages;
